import React from 'react';
import { observer } from 'mobx-react';

import { analytics } from 'core/analytics';
import { useRouterStore, useClientStore } from 'apps/hooks';
import { CADComparisonHeight } from 'styles/constants';
import { useViewerControl } from 'libs/rendering/gltf/hooks';

import { Panel } from '../panel';
import DiffAnalysis from './diffAnalysis';

const DiffPanel = observer(() => {
  const routerStore = useRouterStore();
  const clientStore = useClientStore();
  const viewerControl = useViewerControl();

  const viewer = viewerControl?.viewer;
  const settings = viewer?.settings;
  const camera = settings?.CurrentCamera();

  function collapseDiffAnalysis() {
    const newParams = Object.assign({}, routerStore.route.params);
    if (newParams.panel === 'diff') {
      delete newParams.panel;
      analytics.sendEvent('diff-tool-hide');
    }

    routerStore.navigate(routerStore.route.name, newParams, {
      replace: true,
    });
  }

  return (
    <Panel
      position='right'
      title='Diff'
      data-testid='DiffPanel'
      iconName='fork'
      removeHeader
      collapseAction={collapseDiffAnalysis}
      isOpen={camera != null}
      top={clientStore.PageHeaderHeight}
      overlayStyle={{ top: 0 }}
    >
      <div
        style={{ minHeight: CADComparisonHeight }}
        className=' text-wfBlack border-b px-4 py-2 border-wfGrey100  flex items-center font-bold overflow-x-scroll overscroll-contain'
      >
        CAD Comparison
      </div>
      <DiffAnalysis />
    </Panel>
  );
});

export default DiffPanel;
